import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from "./views/Login"
import Lobby from './views/Lobby.vue'
import Registrieren from './views/Registrieren.vue'
import Verify from "./views/Verify"
import PwReset from "./views/PwReset"
import Service from "./views/Service"
import Service_Users from "./views/Service_Users";
import Service_User from "./views/Service_User";
import Service_Logs from "./views/Service_Logs";
import Maintenance from "./views/Maintenance"
import Service_Email from "./views/Service_Email";
import Service_Sms from "./views/Service_Sms";
import AccountProfile from "@/views/AccountProfile";
import AccountErfolgsmatrix from "@/views/AccountErfolgsmatrix";
import AccountActivities from "@/views/AccountActivities";
import Eingabe from "@/views/Eingabe";
import Stoppuhr from "@/views/Stoppuhr";
import Counters from "@/views/Counters";
import AccountSettings from "@/views/AccountSettings";
import FeedbackSettings from "@/views/FeedbackSettings";
import Feedback from "@/views/Feedback";
import TeamSettings from "@/views/TeamSettings";
import TeamMember from "@/views/TeamMember";
import Service_Stats from "@/views/Service_Stats";
import TeamDashboard from "@/views/TeamDashboard";
import TeamLeaderboard from "@/views/TeamLeaderboard";
import Leistungen from "@/views/Leistungen";
import ZieleNachDatum from "@/views/ZieleNachDatum";
import Workbook from "@/views/Workbook";
import Danke from "@/views/Danke";
import Hilfe from "@/views/Hilfe";
import Wochenreport from "@/views/Wochenreport";

Vue.use(VueRouter)

  const routes = [
    { path: '/', redirect: '/login' },
    { path: '/login/:email?', component: Login },
    { path: '/signup/:data?', component: Registrieren },
    { path: '/registrieren/:data?', redirect: '/signup/:data?' },
    { path: '/datenschutz', component: () => import(/* webpackChunkName: "datenschutz" */ './views/Datenschutz.vue') },
    { path: '/impressum', component: () => import(/* webpackChunkName: "datenschutz" */ './views/Impressum.vue') },
    { path: '/agb', component: () => import(/* webpackChunkName: "datenschutz" */ './views/AGB.vue') },
    { path: '/pw_reset/:id?', component: PwReset },
    { path: '/verify/:id?', component: Verify },
    { path: '/lobby', redirect: '/dashboard' },
    { path: '/dashboard/:date?/:bereichNr?', component: Lobby },
    { path: '/profil', component: AccountProfile },
    { path: '/erfolgsmatrix', component: AccountErfolgsmatrix },
    { path: '/activities', component: AccountActivities },
    { path: '/eingabe/:date?', component: Eingabe },
    { path: '/stoppuhr/:aid?', component: Stoppuhr },
    { path: '/counters', component: Counters },
    { path: '/notification_settings', component: AccountSettings },
    { path: '/feedback_settings', component: FeedbackSettings },
    { path: '/feedback/:data', component: Feedback },
    { path: '/team_settings', component: TeamSettings },
    { path: '/team_member/:email', component: TeamMember },
    { path: '/team_dashboard/:date?/:bereichNr?', component: TeamDashboard },
    { path: '/team_leaderboard/:date?', component: TeamLeaderboard },
    { path: '/achievements', component: Leistungen },
    { path: '/ziele', component: ZieleNachDatum },
    { path: '/workbook', component: Workbook },
    { path: '/danke', component: Danke },
    { path: '/help', component: Hilfe },
    { path: '/report/:date?', component: Wochenreport },
    {
      path: '/service', name: 'Service', component: Service,
      children: [
        { path: 'stats', component: Service_Stats, },
        { path: 'users', component: Service_Users, },
        { path: 'user/:email', component: Service_User, },
        //{ path: 'logs', component: Service_Logs, },
        //{ path: 'maintenance', component: Maintenance, },
        { path: 'email', component: Service_Email, },
        { path: 'email_editor/:id', component: () => import(/* webpackChunkName: "emaileditor" */ './views/Service_EmailEditor.vue'), },
        { path: 'sms', component: Service_Sms, },
      ]
    },
]

const router = new VueRouter({
  //mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
